import { useCallback, useEffect, useRef, useState } from 'react';
export function useCartPreBook() {
    const [hotels, setHotels] = useState(undefined);
    const pendingConfirmation = useRef(undefined);
    const confirmWarnings = useCallback((warnings) => new Promise(resolve => {
        var _a;
        (_a = pendingConfirmation.current) === null || _a === void 0 ? void 0 : _a.call(pendingConfirmation, false);
        pendingConfirmation.current = resolve;
        setHotels(warnings);
    }), []);
    const decide = useCallback((accepted) => {
        const resolve = pendingConfirmation.current;
        pendingConfirmation.current = undefined;
        setHotels(undefined);
        resolve === null || resolve === void 0 ? void 0 : resolve(accepted);
    }, []);
    useEffect(() => () => {
        var _a;
        (_a = pendingConfirmation.current) === null || _a === void 0 ? void 0 : _a.call(pendingConfirmation, false);
        pendingConfirmation.current = undefined;
    }, []);
    return { hotels, confirmWarnings, decide };
}
